import { ChangeDetectionStrategy, Component } from '@angular/core';
import { APP_STORES, PAYMENTS } from '../content';
import { RevealDirective } from '../reveal.directive';

/**
 * The mobile app, and the ways to pay: a dark card with the two store
 * buttons and the payment logos beside a phone on which this page scrolls by.
 */
@Component({
  selector: 'app-mobile-app',
  imports: [RevealDirective],
  templateUrl: './mobile-app.html',
  styleUrl: './mobile-app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileApp {
  protected readonly stores = APP_STORES;
  protected readonly payments = PAYMENTS;
  /** no store has the app yet: the buttons are not links, and a line under them says so */
  protected readonly comingSoon = APP_STORES.every((store) => !store.href);
}
